import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import DateUtils from '@shared/utils/date.utils';

@Pipe({
  name: 'dateAgo',
  standalone: false,
})
export class DateAgoPipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(date: string): string {
    const parsedDate = Date.parse(date);
    if (date && !isNaN(parsedDate)) {
      const seconds = Math.floor(
        (+new Date(DateUtils.getCurrentNOTime()) - +new Date(date)) / 1000
      );

      if (seconds < 29)
        // less than 30 seconds ago will show as 'Just now'
        return this.translate.instant('General.JustNow');
      const intervals: { [key: string]: number } = {
        Year: 31536000,
        Month: 2592000,
        Week: 604800,
        Day: 86400,
        Hour: 3600,
        Minute: 60,
        Second: 1,
      };
      let intervalCounter;
      for (const i in intervals) {
        intervalCounter = Math.floor(seconds / intervals[i]);
        if (intervalCounter > 0)
          if (intervalCounter === 1) {
            return (
              intervalCounter +
              ' ' +
              this.translate.instant(`General.${i}`) +
              ' ' +
              this.translate.instant('General.Ago')
            );
          } else {
            return (
              intervalCounter +
              ' ' +
              this.translate.instant(`General.${i}.Plural`) +
              ' ' +
              this.translate.instant('General.Ago')
            );
          }
      }
    }
    return date;
  }
}
